module.exports = __webpack_public_path__ + "img/stage4.6aa41274.svg";